import dayJS from 'dayjs'

/** Returns whether or not the date is in the past
 * @param { Date } date the data to parses
 */
export function isPastAndNotToday(date: Date): boolean {
  if (date) {
    const isPassed = dayJS().diff(date) > 0
    const isToday = dayJS(date).isSame(dayJS(), 'day')

    if (isPassed && !isToday) {
      return true
    }
  }

  return false
}
